import type { ChainModifiers, Entry, EntryFieldTypes, EntrySkeletonType, LocaleCode } from 'contentful';

import type { TypeCtaSkeleton } from './TypeCta';
import type { TypeProductCardSkeleton } from './TypeProductCard';

export interface TypeBlockProductsFields {
    internalName: EntryFieldTypes.Symbol;
    visibility?: EntryFieldTypes.Symbol<'loggedIn' | 'loggedOut'>;
    title?: EntryFieldTypes.Symbol;
    productsQuery?: EntryFieldTypes.EntryLink<TypeProductCardSkeleton>;
    cta?: EntryFieldTypes.EntryLink<TypeCtaSkeleton>;
}

export type TypeBlockProductsSkeleton = EntrySkeletonType<TypeBlockProductsFields, 'blockProducts'>;
export type TypeBlockProducts<Modifiers extends ChainModifiers, Locales extends LocaleCode = LocaleCode> = Entry<
    TypeBlockProductsSkeleton,
    Modifiers,
    Locales
>;

export function isTypeBlockProducts<Modifiers extends ChainModifiers, Locales extends LocaleCode>(
    entry: unknown,
): entry is TypeBlockProducts<Modifiers, Locales> {
    const candidate = entry as { sys?: { contentType?: { sys?: { id?: string } } } };

    return candidate.sys?.contentType?.sys?.id === 'blockProducts';
}
